import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFlag1"><Path d="M4 2V22H5.5V15.5H21.6514L17.1514 8.75L21.6514 2H4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFlag1;
